import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

import { useAccountStore } from '@/stores/account';
import { computed } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Program',
  setup(__props) {

const router = useRouter()
const accountStore = useAccountStore()
const programId = computed(() => {
  return router.currentRoute.value.params.programId as string
})

const paths = computed(() => [
  `/programs/${programId.value}/`,
  `/programs/${programId.value}/roadmap`,
  `/programs/${programId.value}/reports`,
  `/programs/${programId.value}/students`
])

const currentTab = computed({
  get() {
    let value = 0
    for (let i = 0; i < paths.value.length; i++) {
      if (router.currentRoute.value.path.startsWith(paths.value[i])) {
        value = i
      }
    }
    return value
  },
  set(value: number)  {
    router.push(paths.value[value])
  }
})


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, { height: "60" }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_v_tabs, {
          key: _unref(programId),
          color: "primary",
          class: "ml-4",
          modelValue: _unref(currentTab),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentTab) ? (currentTab).value = $event : null))
        }, {
          default: _withCtx(() => [
            (_unref(accountStore).isDirector)
              ? (_openBlock(), _createBlock(_component_v_tab, {
                  key: 0,
                  value: 0,
                  height: "60",
                  exact: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { class: "mr-1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-chart-pie")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" Аналитика ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_tab, {
              value: 1,
              height: "60",
              exact: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-view-grid")
                  ]),
                  _: 1
                }),
                _createTextVNode(" Дорожная карта ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_tab, {
              value: 2,
              height: "60",
              exact: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-file-document")
                  ]),
                  _: 1
                }),
                (_unref(accountStore).isDirector)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Таблица отчетов")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Отчеты трекера")
                    ], 64))
              ]),
              _: 1
            }),
            (_unref(accountStore).isDirector)
              ? (_openBlock(), _createBlock(_component_v_tab, {
                  key: 1,
                  value: 3,
                  height: "60",
                  exact: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { class: "mr-1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-star")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" Оценки студентов ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      ]),
      _: 1
    }),
    _createVNode(_component_router_view)
  ], 64))
}
}

})